/**
 * @Author: v_jppjpeng
 * @Date: 2024-04-30 15:15:08
 * @Explain: 联系人 - 预约模板
 */

import { defaultForm } from '@/pages/contactManage/utils/config/newsletter';
import { FormDataType } from '@/pages/contactManage/utils/typings/newsletter';

/** 参数声明 */
export type NewsletterState = {
  /** 预约模板 - 表单 */
  newsletterFormData: FormDataType;
};

export type ModelType = {
  namespace: string;
  state: NewsletterState;
  reducers: {
    /** 预约模板 - 表单 */
    setNewsletterFormData: (
      state: NewsletterState,
      action: { payload: any },
    ) => any;
  };
};

const NewsletterModel: ModelType = {
  namespace: 'NewsletterModel',
  state: {
    newsletterFormData: { ...defaultForm },
  },
  reducers: {
    setNewsletterFormData(state, action) {
      return {
        ...state,
        newsletterFormData: action.payload,
      };
    },
  },
};

export default NewsletterModel;
